<template>
  <div>
    <div v-show="isForeign">
      <div id="embed-target"></div>
    </div>
    <div class="order-room container" v-show="!isForeign">
      <div class="good-detail">
        <el-image
            class="img"
            :src="coverImage"
        />
        <div class="detail-box">
          <div class="title">
            <p class="main-info">{{ mainInfo }}</p>
            <!-- <p class="explain">1份早餐 1张大床</p> -->
          </div>
          <div class="price" v-if="goodsList.length">
            <p>￥{{ goodsList[0].price }}</p>
          </div>
          <div class="time-day">{{ goodsDataParams.startTime }} 至 to {{ goodsDataParams.endTime }}</div>
          <div class="time-day">共 Total {{ dateLength }} 晚 nights</div>
        </div>
      </div>
      <div class="book-info">
        <div class="room-info">
          <p>房间数 Number of rooms</p>
          <el-input-number v-model="confirmData.qty" :min="1" :max="999" @change="handleChange"></el-input-number>
        </div>
        <div class="room-info">
          <p>联系人 Contact person</p>
          <el-input
              class="ainput-number"
              v-model="confirmData.buyerName"
              placeholder="请输入联系人姓名 Please enter the name of the contact"
          ></el-input>
        </div>
        <div class="room-info">
          <p>联系电话 Contact number</p>
          <el-input
              class="ainput-number"
              v-model="confirmData.buyerMobile"
              placeholder="请输入联系人手机 Please enter your contact’s phone number"
          ></el-input>
        </div>
        <div class="room-info">
          <p>备注信息 Remarks</p>
          <el-input
              class="ainput-number"
              type="textarea"
              maxlength="15"
              show-word-limit
              v-model="confirmData.summary"
              placeholder="请输入15字以内备注信息 Please enter information in 15 words or less"
          ></el-input>
        </div>
      </div>
      <section class="mar-t-60 mar-b-60" v-if="couponList.length">
        <div class="coupon-info">优惠券 Coupons</div>
        <SelectCoupons :couponList="couponList" :qrCode.sync="qrCode" @postQrcode="getQrcode"/>
      </section>
      <section class="discounts-reckon">
        <div class="discounts-item fl-align-center primary-text">
          <span>总价 Total price</span>
          <span class="price-value">￥{{ copeAmount }}</span>
        </div>
        <div class="discounts-item fl-align-center primary-text">
          <span>商品优惠 Discount</span>
          <span class="price-value">￥{{ goodsDecrAmount }}</span>
        </div>
        <div class="discounts-item fl-align-center primary-text">
          <span>优惠 Special offer</span>
          <div class="price-discount-wrap">
            <span class="price-value">-￥{{ totalDecrAmount }}</span>
            <span v-if="hitPolicy.discount" class="price-discount">提前{{hitPolicy.days}}天预定享受{{hitPolicy.discount}}折优惠</span>
          </div>
        </div>
        <div class="discounts-item fl-align-center primary-text">
          <span>合计 payAmount</span>
          <span class="price-value">￥{{ payAmount }}</span>
        </div>
        <div class="discounts-item flex primary-text">
          <div>支付方式 Payment method</div>
          <el-radio-group v-model="paymentMethod" class="price-value price-radio">
            <el-radio
                v-for="item in paymentMethodOptions"
                :key="item.value"
                :label="item.value">
              <span class="radio-text">{{ item.label }}</span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="submit-order-btn">
          <el-button type="primary" size="default" :loading="payLoading" @click="toPayWay">提交订单 Submit an order
          </el-button>
        </div>
      </section>
      <SharePayDialog
          title="微信扫码完成支付 Scan the QR code to pay"
          v-if="sharePayVisible"
          :visible.sync="sharePayVisible"
          :payImg="payImg"
          @on-success="getOrderStatus"
      />
    </div>
  </div>

</template>

<script>
import SharePayDialog from "../eshop/components/SharePayDialog.vue";
import SelectCoupons from "@/components/base/SelectCoupons";
import {hotelOrderCreditCallback} from "@/api/api";
import {paymentMethodOptions} from "@/util/options";

export default {
  name: "OrderRoom",
  components: {SelectCoupons, SharePayDialog},
  data() {
    return {
      payLoading: false,
      isForeign: false,//是否是外币支付
      paymentMethod: 'wechat',//支付方式
      paymentMethodOptions: this.$optionsData.paymentMethodOptions,
      sharePayVisible: false,
      payImg: "", //小程序订单分享页面
      orderNo: "", //订单号
      couponList: [],
      goodsList: [],
      mainInfo: "", //券名稱
      qrCode: "", //选中的通用券码
      goodsDataParams: {},
      totalDecrAmount: "", //优惠
      copeAmount: "", //总价
      payAmount: "", //合计
      coverImage: "",
      goodsDecrAmount: "", //商品優惠
      isFirst: 1, //是否是首次进入
      dateLength: 0,
      confirmData: {
        qty: 1,
        buyerName: "",
        buyerMobile: "",
        summary: "",
      },
      hitPolicy: {}
    };
  },
  props: {},
  computed: {},
  async mounted() {
    const _this = this
    await this.getGoodsData();
    await this.getCheckRooms();
    await this.getHotelOrderConfirmOrder(1);
    window.checkoutOrderBack = function (type, message) {
      if (type == 'error') {
        _this.isForeign = false
        _this.$message.error(message)
      } else if (type == 'complete') {
        _this.foreignPayComplete()
      }
    }
  },
  methods: {
    //外币支付完成，通知服务器更新订单信息
    async foreignPayComplete() {
      const loading = this.$loading({
        lock: true,
        text: '同步订单信息',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      })
      const orderNo = this.orderNo
      await this.$api.hotelOrderCreditCallback({orderNo}).then(res => {
        const apiResult = res.data?.apiResult
        if (apiResult != "SUCCESS") {
          this.$message.warning('订单数据同步失败')
        }
        this.$router.push(`/home/pay-result?orderNo=${this.orderNo}`);
        loading.close()
      }).catch(() => {
        this.$message.warning('订单数据同步失败')
        this.$router.push(`/home/pay-result?orderNo=${this.orderNo}`);
        loading.close()
      })
    },
    //获取支付码
    async getAppletCode() {
      // let { data } = await this.$api.createLink({
      //   content: JSON.stringify({ orderNo: this.orderNo }),
      // });
      const params = {
        page: `implant/hotelOrders/detail/index`,
        scene: this.orderNo
      };
      try {
        let {data} = await this.$api.getQrCode(params).catch(() => {
          this.payLoading = false
        });
        this.payImg = data;
        this.sharePayVisible = true;
      } catch (error) {
        console.log(error);
      }
    },
    //查询订单详情
    async getHotelOrderDetail() {
      const params = {
        orderNo: this.orderNo,
      };
      try {
        let {data} = await this.$api.getHotelOrderDetail(params);
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    //获取支付状态
    async getOrderStatus() {
      const data = await this.getHotelOrderDetail();
      if (data.orderVO && data.orderVO.payTime) {
        await this.$router.push(`/home/pay-result?orderNo=${this.orderNo}`);
        this.sharePayVisible = false;
      } else {
        this.$message.warning("支付未完成");
      }
    },

    async getDateLength(start, end) {
      return (new Date(end).getTime() - new Date(start).getTime()) / (3600 * 24 * 1000);
    },
    async getGoodsData() {
      let obj = this.$route.query;
      this.goodsDataParams = obj;
      let timeLength = await this.getDateLength(obj.startTime, obj.endTime);
      this.dateLength = timeLength;
    },
    async getCheckRooms() {
      const params = {
        endDate: this.goodsDataParams.endTime,
        goodsId: this.goodsDataParams.id,
        qrCode: "",
        qty: 1,
        startDate: this.goodsDataParams.startTime,
        channelCode: this.goodsDataParams.channelCode,
      };
      let {data} = await this.$api.getCheckRooms(params);
    },
    async getHotelOrderConfirmOrder(isFirst = 0) {
      const params = {
        ...this.confirmData,
        endDate: this.goodsDataParams.endTime,
        goodsId: this.goodsDataParams.id,
        isFirst: isFirst,
        qrCode: this.qrCode,
        shareVisitCode: "",
        startDate: this.goodsDataParams.startTime,
        channelCode: this.goodsDataParams.channelCode,
      };
      let {data} = await this.$api.getHotelOrderConfirmOrder(params);
      this.totalDecrAmount = data.totalDecrAmount || "";
      this.copeAmount = data.copeAmount || "";
      this.payAmount = data.payAmount || "";
      this.coverImage = data.coverImage || "";
      this.goodsDecrAmount = data.goodsDecrAmount || "";
      this.couponList = data.couponList || [];
      this.goodsList = data.goodsList || [];
      this.qrCode = data.qrCode;
      this.mainInfo = data.name;
      this.isFirst = 0;
      this.hitPolicy = data.hitPolicy || {};
    },
    //获取qrcode
    getQrcode(val) {
      this.qrCode = val;
      this.getHotelOrderConfirmOrder();
    },
    handleChange(value) {
      this.confirmData.qty = value;
      this.getHotelOrderConfirmOrder();
    },
    //微信支付
    async wechatPayment(orderNo, buyType) {
      try {
        if (buyType == 1) {
          await this.$router.push(`/home/pay-result?orderNo=${orderNo}`);
        } else if (buyType == 0) {
          await this.getAppletCode();
        }
      } catch (error) {
        console.log(error);
      }
    },
    //外币支付
    foreignPayment: async function (orderNo, totalAmount) {

      let {data} = await this.$api.getSession({
        "amount": totalAmount,
        "orderNo": orderNo
      }).catch(() => {
        this.payLoading = false
      })
      if (!data) return;
      this.isForeign = true
      Checkout.configure({
        session: {
          id: data.id
        },
        order: {
          description: 'BEIJING INTERNATIONAL HOTEL',
          id: orderNo
        },
        interaction: {
          merchant: {
            name: 'BEIJING INTERNATIONAL HOTEL',
            address: {
              line1: 'The Beijing International Hotel Convention Center',
              line2: 'Adjacent to the main hotel building'
            }
          }
        }
      });

      Checkout.showEmbeddedPage('#embed-target',
          () => {
            console.log('showLightboxFunc')
          }
      );
    },
    //支付按钮点击事件
    async toPayWay() {
      if (!this.confirmData.buyerName) {
        this.$message.error("请输入联系人姓名");
        return;
      }
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.confirmData.buyerMobile)) {
        this.$message.error("联系人联系手机号输入错误，请重新填写");
        return;
      }
      let params = {
        ...this.confirmData,
        endDate: this.goodsDataParams.endTime,
        goodsId: this.goodsDataParams.id,
        isFirst: this.isFirst,
        qrCode: this.qrCode,
        shareVisitCode: "",
        startDate: this.goodsDataParams.startTime,
        channelCode: this.goodsDataParams.channelCode,
      };
      try {
        this.payLoading = true
        const {data} = await this.$api.getHotelBuyGoods(params).catch(() => {
          this.payLoading = false
        });
        let {orderNo, buyType, totalAmount} = data;
        this.orderNo = orderNo;
        if (this.paymentMethod == 'wechat') {
          await this.wechatPayment(orderNo, buyType)
        } else if (this.paymentMethod == 'foreign') {
          await this.foreignPayment(orderNo, totalAmount)
        }
        this.payLoading = false
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.order-room {
  margin-top: 60px;
}

.good-detail {
  width: 100%;
  height: 148px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  background: #fcfcfc;
  border: 1px solid #f0f0f0;

  .img {
    width: 88px;
    height: 88px;
    flex: none;
  }

  .detail-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    margin-left: 20px;

    .title {
      display: flex;
      flex-direction: column;

      .main-info {
        font-size: 14px;

        font-weight: 400;
        color: #333333;
      }

      .explain {
        font-size: 14px;

        font-weight: 400;
        color: #999999;
        margin-top: 19px;
      }
    }

    .price {
      p {
        font-size: 14px;

        font-weight: bold;
        color: #333333;

        &:nth-child(2) {
          margin-top: 18px;
        }
      }
    }

    .time-day {
      font-size: 14px;

      font-weight: 400;
      color: #333333;
    }
  }
}

.book-info {
  margin-top: 60px;
  padding-bottom: 60px;
  border-bottom: 1px solid #f0f0f0;

  .room-info {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    p {
      width: 240px;
      font-size: 14px;

      font-weight: 400;
      color: #333333;
    }
  }
}

.mar-t-60 {
  margin-top: 60px;
}

.mar-b-60 {
  margin-bottom: 60px;
}

.coupon-info {
  font-size: 18px;

  font-weight: bold;
  color: #333333;
}

.coupon-list {
  width: 100%;
  display: flex;
  flex-flow: wrap;
  padding-bottom: 60px;
  border-bottom: 1px solid #f0f0f0;
}

.discounts-reckon {
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;

  .discounts-item {
    justify-content: flex-end;
    margin-top: 30px;

    .price-value {
      width: 410px;
      text-align: right;
      padding-left: 20px;
      white-space: nowrap;
      margin-left: 20px;
      box-sizing: border-box;
    }
    .price-discount-wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .price-discount {
      color: #E47C47;
      font-size: 12px;
      margin-top: 4px;
    }
  }

  .submit-order-btn {
    text-align: right;
    margin-top: 38px;
    padding-bottom: 70px;
  }
}

/deep/ .ainput-number {
  width: 500px;
}

/deep/ textarea {
  width: 500px;
  height: 100px;
  border: 1px solid #cccccc;
}

/deep/ .el-textarea .el-textarea__inner {
  resize: none;
}
.price-radio {
  text-align: left;
  border: 1px solid #DCDFE6;
  padding: 10px;
}
.radio-text {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
/deep/ .el-radio {
  display: block;
  text-align: left;
}
/deep/ .el-radio + .el-radio {
  margin-top: 10px;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  background: #E47C47 !important;
  border-color: #E47C47 !important;
}
/deep/ .el-radio.is-checked .radio-text {
  color: #E47C47 !important;
}
.flex {
  display: flex;
}
</style>
